import { useQuery } from "@tanstack/react-query";
import { useApi } from "../../../../api/ApiProvider";
import { PatientBillInfoDto } from "../../../../api-client";
import { transactionKeys } from "../../../../stores/Transactions/transaction.keys";
import { useCallback } from "react";

export function usePatientExistingRxData(patientId: number, rxId: string) {
  const { transaction } = useApi();

  return useQuery<PatientBillInfoDto[], Error, PatientBillInfoDto | null>({
    queryKey: transactionKeys.patientBillsInfo.forPatient(patientId),
    queryFn: () => transaction.patientBillInfo(patientId),
    enabled: !!patientId && !!rxId,
    staleTime: 2 * 60 * 1000,
    refetchOnWindowFocus: false,
    placeholderData: (prev) => prev,
    select: (bills) =>
      rxId ? bills.find((b) => b.rxId === rxId) ?? null : null,
  });
}
